<template>
  <div class="anchor-header">
    <div class="anchor-header-bg">
      <div class="align">
        <div class="anchor-icon-contain align jus">
          <img :src="$_.get(anchorBasicInfo, 'avatar')" alt="">
        </div>
        <div class="anchor-name-id">
          <div class="anchor-name">{{$_.get(anchorBasicInfo,'name')}}</div>
          <div class="anchor-id">快手号：<span>{{$_.get(anchorBasicInfo, 'platformId')||$_.get(anchorBasicInfo, 'userId')}}</span></div>
          <slot></slot>
        </div>
        <div class="monitor" @click="monitor()" v-if="showMonitor">
          {{anchorBasicInfo.isSubscribe?'已监控':'监控'}}
        </div>
      </div>
    </div>
    <div class="sex-and-other">
      <div class="align">
        <div class="item">
          性别：{{gender[$_.get(anchorBasicInfo, 'gender')]}}
        </div>
        <div class="item">
          星座：{{$_.get(anchorBasicInfo, 'constellation')}}
        </div>
        <div class="item">
          地址：{{$_.get(anchorBasicInfo, 'region')}}
        </div>
      </div>
<!--      <div class="memo align" id="memoMore" @click="toggleMore()">-->
<!--        <div class="memo-info oneLine">简介：{{$_.get(anchorBasicInfo, 'memo')}}</div>-->
<!--        <div class="icon">联系ta</div>-->
<!--      </div>-->
    </div>
<!--    <van-popup v-model="more">-->
<!--      <AnchorContact :links="links" :vip="$_.get(anchorBasicInfo, 'contact')"></AnchorContact>-->
<!--    </van-popup>-->
  </div>
</template>

<script>
  export default {
    props: {
      anchorBasicInfo: {
        type: Object,
      },
      showMonitor: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      links() {
        let linksArray = []
        Object.keys(this.$_.get(this, 'anchorBasicInfo.contact', {})||{}).forEach(keys=>{
          if(this.meaning[keys]&&this.$_.get(this, `anchorBasicInfo.contact.${keys}`, {})!=='-') {
            linksArray = linksArray.concat(this.anchorBasicInfo.contact[keys].split('#').map(ele=>{
              return {
                label: this.meaning[keys].label,
                value: ele,
                key: this.meaning[keys].key
              }
            }))
          }
        })
        return linksArray.sort((a,b)=>a.key-b.key)
      }
    },
    data() {
      return {
        more: false,
        gender: {
          0: '女',
          1: '男',
        },
        meaning: {
          cellphone: {
            label: '手机',
            key: 3
          },
          qq: {
            label: 'QQ',
            key: 1
          },
          wechat: {
            label: '微信',
            key: 2
          },
        },
      }
    },
    methods: {
      toggleMore() {
        if(this.$store.state.userLevel) {
          this.more = !this.more
        }else {
          this.$store.commit('WRITEOVERLAYSHOW', {status: true,textChange: 'vipOnly', yearVipOnly: {0: true,2: true}})
        }
      },
      monitor() {
        this.$store.dispatch('isVip')
        .then(res=>{
          if(this.anchorBasicInfo.isSubscribe) {
            this.delMonitor()
          }else {
            this.putMonitor()
          }
        })
        .catch(err=>{
          this.$store.commit('WRITEOVERLAYSHOW', {status: true})
        })
      },
      putMonitor() {
        if(this.$store.state.userLevel<=100) {
          this.$dialog.confirm({
            title: '提示',
            message: `您将开启对${this.$_.get(this.anchorBasicInfo,'name')}的直播监控，开启后，当该播主再次直播结束即可获得分析数据`
          }).then(() => {
            // 清空弹窗
            this.$toast.clear();
            // 出现loading
            this.$showLoading();
            // 数据发送
            this.$put({
              road: 'liveStream',
              data: {
                road: 'gifshow'
              },
              params: {userId: this.$_.get(this.anchorBasicInfo,'userId'), barrage: true},
              version: 'v2'
            })
            .then(res=>{
              this.$toast.clear();
              this.$toast('监控成功');
              this.$set(this.anchorBasicInfo, `isSubscribe`, true);
            })
            .catch(err=>{
              this.$toast.clear();
              this.$showNoneMonitor();

              this.$store.commit('WRITEOVERLAYSHOW', {status: true})
            })
          }).catch((e) => {
            // on cancel
          });
        }else {
          this.$store.commit('WRITEOVERLAYSHOW', {status: true})
        }
      },
      delMonitor() {
        this.$dialog.confirm({
          title: '提示',
          message: `您将取消对${this.$_.get(this.anchorBasicInfo, 'name')}的直播监控，取消后，将不再获得该播主的直播分析和电商分析数据`
        }).then(() => {
          this.$toast.clear();
          this.$showLoading()
          this.$del({
            road: 'liveStream',
            data: {
              road: 'gifshow'
            },
            params: {userId: this.$_.get(this.anchorBasicInfo,'userId'), barrage: true},
            version: 'v2'
          })
          .then(res => {
            this.$toast.clear();
            this.$toast(`取消成功`);
            this.$set(this.anchorBasicInfo, `isSubscribe`, false);
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast('取消失败');
          })
        }).catch((e) => {
        });
      },
    },
  }
</script>

<style lang="less" scoped>
  .anchor-header-bg {
    height: 2.04rem;
    width: 100vw;
    background-image: url('../static/images/anchor-detail-bg.png');
    background-size: cover;
    padding: .2rem .3rem 0;
    .anchor-icon-contain {
      width: 1.6rem;
      height: 1.6rem;
      border-radius: 100%;
      background: #fff;
      img {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
      }
    }
    .anchor-name-id {
      margin-left: 0.3rem;
      color: #fff;
      width: 5rem;
      .anchor-name {
        font-size: .36rem;
        color: #fff;
      }
      .anchor-id {
        color: #CAD3DF;
        margin-top: 0.2rem;
        font-size: .26rem;
        span {
          color: #fff;
        }
      }
    }
    .monitor {
      width: 1.6rem;
      height: 0.6rem;
      border: .01rem solid #FF9900;
      color: #FF9900;
      font-size: .28rem;
      text-align: center;
      line-height: 0.58rem;
      border-radius: .6rem;
      background: #fff;
    }
  }
  .sex-and-other {
    color: #A1AEBF;
    padding: 0.3rem; 
    font-size: .24rem;
    background: #fff;
    .align {
      .item {
        margin-right: 0.4rem;
      }
    }
     .memo {
      margin-top: 0.2rem;
      line-height: 0.3rem;
      transition: all .3s linear;
      height: 0.3rem;
      position: relative;
      .memo-info {
        width: 6.2rem;
        height: 0.3rem;
        overflow: hidden;
      }
      .icon {
        width:1rem;
        height:.40rem;
        background:rgba(42,137,244,1);
        border-radius: .04rem;
        color: #fff;
        font-size: .24rem;
        text-align: center;
        line-height: 0.4rem;
      }
    }
  }
</style>